import { render, staticRenderFns } from "./toolbarStatistiche.html?vue&type=template&id=4c81837a&"
import script from "./ToolbarStatistiche.vue?vue&type=script&lang=js&"
export * from "./ToolbarStatistiche.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports